// extracted by mini-css-extract-plugin
export default {"events":"TimelineEvents_events__IHY4W","section":"TimelineEvents_section__bRTv0","currentEvent":"TimelineEvents_currentEvent__8Qbsy","nextEvent":"TimelineEvents_nextEvent__Al22K"};